// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.37
   Code Gen Name   Numbers
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     7/12/2024 1:57:59 PM
************************************************/

export enum NumbersMetaDataItemNames {
    EmaulationUser = 'EmaulationUser',
    EthosJobNumber = 'Ethos_JobNumber',
    EthosJobNumberForecast = 'Ethos_JobNumberForecast',
    EthosJobNumberMembership = 'Ethos_JobNumberMembership',
    EthosJobNumberPhase = 'Ethos_JobNumberPhase',
    EthosJobNumberPriority = 'Ethos_JobNumberPriority',
    EthosRoUserLaborSummary = 'Ethos_roUserLaborSummary',
    EthosServiceUser = 'Ethos_ServiceUser',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    EthosWachterTeam = 'Ethos_WachterTeam',
    NumbersRoUserProjection = 'numbers_roUserProjection',
    OverheadProjection = 'OverheadProjection',
    OverheadTeamPhase = 'OverheadTeamPhase',
    RoEthosUser = 'roEthos_User',
    RoEthosUserOriginal = 'roEthos_UserOriginal',
    RoEthosTeamsAndOrganizationalUnits = 'roEthosTeamsAndOrganizationalUnits',
    RoNspCommittedByTeam = 'roNspCommittedByTeam',
    RoNspDwFinancialsByTeamByYear = 'roNspDwFinancialsByTeamByYear',
    RoNspDwOverheadByDepartmentByYear = 'roNspDwOverheadByDepartmentByYear',
    RoNspDwOverheadByTeamByYear = 'roNspDwOverheadByTeamByYear',
    RoNspFinancialNumbersByTeamByYear = 'roNspFinancialNumbersByTeamByYear',
    RoNspFinancialNumbersByTeamByYearBackup = 'roNspFinancialNumbersByTeamByYear_Backup',
    RoNspFinancialNumbersByTeamByYearOLD = 'roNspFinancialNumbersByTeamByYearOLD',
    RoNspOverheadProjectedByDepartmentByYear = 'roNspOverheadProjectedByDepartmentByYear',
    RoNspOverheadProjectedByTeamByYear = 'roNspOverheadProjectedByTeamByYear',
    RoNspProjectedByTeam = 'roNspProjectedByTeam',
    RoOrganizationalTeamUnitDept = 'roOrganizationalTeamUnitDept',
    RoOverheadCommittedByJobPhaseYear = 'roOverheadCommittedByJobPhaseYear',
    RoOverheadProjectedByJobPhaseYear = 'roOverheadProjectedByJobPhaseYear',
    RoOverheadProjectionByTeam = 'roOverheadProjectionByTeam',
    RoProjectManagersTeamUnitDept = 'roProjectManagersTeamUnitDept',
    RoUserProjection = 'roUserProjection',
    RoUserProjectionAnalyzed = 'roUserProjectionAnalyzed',
    TeamYearNumbers = 'TeamYearNumbers',
    TrustUserMerged = 'TrustUserMerged',
    UserExtended = 'UserExtended',
    UserTeamLookup = 'UserTeamLookup',
    UserYearNumbers = 'UserYearNumbers',
    WachterTeamDepartment = 'WachterTeamDepartment',
    WcUserProjection = 'wc_UserProjection',
}

export enum NumbersMetaDataLookups {
    ActiveJobNumberForKickoff = 2934,
    EmaulationUserAllItems = 1644,
    EmployeesByDeptIncTrainees = 2812,
    EthosJobNumberActiveOnlyForKickoff = 1750,
    EthosJobNumberEJNPJNFJN = 2869,
    EthosJobNumberAllItems = 1378,
    EthosJobNumberEndDate = 1504,
    EthosJobNumberForecastAllItems = 1377,
    EthosJobNumberMembershipAllItems = 2867,
    EthosJobNumberPhaseAllItems = 1588,
    EthosJobNumberPriorityAllItems = 2866,
    EthosServiceUserAllItems = 1774,
    EthosUserBySupervisor = 1758,
    EthosUserBySupervisorPlusIndirect = 1773,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERNSPLBUOfficeActiveEmployees = 1696,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserEmployeeGroups = 2858,
    EthosUserSkillAllItems = 1413,
    EthosWachterTeamDivisionDepartment = 1496,
    EthosWachterTeamNSPLBU = 1709,
    EthosWachterTeamAllItems = 1415,
    EthosWachterTeamAllItemsWithDivision = 1860,
    JobNumberActive = 1872,
    JobNumberToCustJobName = 2870,
    OverheadJobNumbers = 1589,
    OverheadJobNumbersActive = 2962,
    OverheadProjectionAllItems = 1547,
    OverheadTeamPhaseAllItems = 1548,
    ProjectKickoffJobNumberFromOpportunity = 2931,
    ProjectManagementTeams = 2961,
    RoEthosUserActiveOnly = 2837,
    RoEthosUserAllActiveThenInactive = 2889,
    RoEthosUserAllItems = 1422,
    RoEthosUserOriginalAllItems = 1753,
    RoEthosTeamsAndOrganizationalUnitsAllItems = 1390,
    RoNspCommittedByTeamAllItems = 1577,
    RoNspDwFinancialsByTeamByYearAllItems = 1568,
    RoNspDwOverheadByDepartmentByYearAllItems = 1557,
    RoNspDwOverheadByTeamByYearAllItems = 1566,
    RoNspFinancialNumbersByTeamByYearAllItems = 1574,
    RoNspFinancialNumbersByTeamByYearOLDAllItems = 1779,
    RoNspOverheadProjectedByDepartmentByYearAllItems = 1572,
    RoNspOverheadProjectedByTeamByYearAllItems = 1580,
    RoNspProjectedByTeamAllItems = 1573,
    RoOrganizationalTeamUnitDeptAllItems = 1563,
    RoOverheadCommittedByJobPhaseYearAllItems = 1564,
    RoOverheadProjectedByJobPhaseYearAllItems = 1562,
    RoOverheadProjectionByTeamAllItems = 1561,
    RoProjectManagersTeamUnitDeptAllItems = 1558,
    RoUserProjectionAllItems = 1533,
    // duplicate lookup meaning found - these should be unique
    RoUserProjectionAllItems_1590 = 1590,
    RoUserProjectionAnalyzedAllItems = 2971,
    TeamYearNumbersAllItems = 1698,
    TrustUserMergedAllItems = 1651,
    UserExtendedAllItems = 1364,
    UserProjectionAllItems = 1546,
    UserTeamLookupAllItems = 1699,
    UserYearNumbersAllItems = 1695,
    WachterTeamByDepartment = 1768,
    WachterTeamDepartmentAllItems = 1497,
}

@Injectable({
    providedIn: 'root'
})
export class NumbersMetaDataService {

    EmaulationUser : EmaulationUserMetaData = new EmaulationUserMetaData();
    EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    EthosRoUserLaborSummary : EthosRoUserLaborSummaryMetaData = new EthosRoUserLaborSummaryMetaData();
    EthosServiceUser : EthosServiceUserMetaData = new EthosServiceUserMetaData();
    EthosUser : EthosUserMetaData = new EthosUserMetaData();
    EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    OverheadProjection : OverheadProjectionMetaData = new OverheadProjectionMetaData();
    OverheadTeamPhase : OverheadTeamPhaseMetaData = new OverheadTeamPhaseMetaData();
    RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    RoEthosTeamsAndOrganizationalUnits : RoEthosTeamsAndOrganizationalUnitsMetaData = new RoEthosTeamsAndOrganizationalUnitsMetaData();
    RoNspCommittedByTeam : RoNspCommittedByTeamMetaData = new RoNspCommittedByTeamMetaData();
    RoNspDwFinancialsByTeamByYear : RoNspDwFinancialsByTeamByYearMetaData = new RoNspDwFinancialsByTeamByYearMetaData();
    RoNspDwOverheadByDepartmentByYear : RoNspDwOverheadByDepartmentByYearMetaData = new RoNspDwOverheadByDepartmentByYearMetaData();
    RoNspDwOverheadByTeamByYear : RoNspDwOverheadByTeamByYearMetaData = new RoNspDwOverheadByTeamByYearMetaData();
    RoNspFinancialNumbersByTeamByYear : RoNspFinancialNumbersByTeamByYearMetaData = new RoNspFinancialNumbersByTeamByYearMetaData();
    RoNspFinancialNumbersByTeamByYearBackup : RoNspFinancialNumbersByTeamByYearBackupMetaData = new RoNspFinancialNumbersByTeamByYearBackupMetaData();
    RoNspFinancialNumbersByTeamByYearOLD : RoNspFinancialNumbersByTeamByYearOLDMetaData = new RoNspFinancialNumbersByTeamByYearOLDMetaData();
    RoNspOverheadProjectedByDepartmentByYear : RoNspOverheadProjectedByDepartmentByYearMetaData = new RoNspOverheadProjectedByDepartmentByYearMetaData();
    RoNspOverheadProjectedByTeamByYear : RoNspOverheadProjectedByTeamByYearMetaData = new RoNspOverheadProjectedByTeamByYearMetaData();
    RoNspProjectedByTeam : RoNspProjectedByTeamMetaData = new RoNspProjectedByTeamMetaData();
    RoOrganizationalTeamUnitDept : RoOrganizationalTeamUnitDeptMetaData = new RoOrganizationalTeamUnitDeptMetaData();
    RoOverheadCommittedByJobPhaseYear : RoOverheadCommittedByJobPhaseYearMetaData = new RoOverheadCommittedByJobPhaseYearMetaData();
    RoOverheadProjectedByJobPhaseYear : RoOverheadProjectedByJobPhaseYearMetaData = new RoOverheadProjectedByJobPhaseYearMetaData();
    RoOverheadProjectionByTeam : RoOverheadProjectionByTeamMetaData = new RoOverheadProjectionByTeamMetaData();
    RoProjectManagersTeamUnitDept : RoProjectManagersTeamUnitDeptMetaData = new RoProjectManagersTeamUnitDeptMetaData();
    RoUserProjection : RoUserProjectionMetaData = new RoUserProjectionMetaData();
    NumbersRoUserProjection : NumbersRoUserProjectionMetaData = new NumbersRoUserProjectionMetaData();
    RoUserProjectionAnalyzed : RoUserProjectionAnalyzedMetaData = new RoUserProjectionAnalyzedMetaData();
    TeamYearNumbers : TeamYearNumbersMetaData = new TeamYearNumbersMetaData();
    TrustUserMerged : TrustUserMergedMetaData = new TrustUserMergedMetaData();
    UserExtended : UserExtendedMetaData = new UserExtendedMetaData();
    WcUserProjection : WcUserProjectionMetaData = new WcUserProjectionMetaData();
    UserTeamLookup : UserTeamLookupMetaData = new UserTeamLookupMetaData();
    UserYearNumbers : UserYearNumbersMetaData = new UserYearNumbersMetaData();
    WachterTeamDepartment : WachterTeamDepartmentMetaData = new WachterTeamDepartmentMetaData();
}

// Generated Classes for MetaData service
export class EmaulationUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmaulationUser.';

    constructor() {
        this.ItemDetail.ItemId=2590;
        this.ItemDetail.ItemName='EmaulationUser';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmulationUserId : string = this.i + 'EmulationUserId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    EmulateEthosUserId : string = this.i + 'EmulateEthos_UserId';

    Relations = {
            /** Relation: Ethos User - Emulated User */
            EthosUserByEmulateEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|EmulateEthos_UserId',
                FieldPrefix: 'EmulateEthosEthosUser',
                PropertyName: 'EmulateEthosEthosUser'
            },
            /** Relation: Ethos User - Logged in  User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosJobNumberMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumber.';

    constructor() {
        this.ItemDetail.ItemId=2375;
        this.ItemDetail.ItemName='Ethos_JobNumber';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumberStatusWs : string = this.i + 'JobNumberStatusWs';
    JobNumberStatus : string = this.i + 'JobNumberStatus';
    JobNumber : string = this.i + 'JobNumber';
    CustomerId : string = this.i + 'CustomerId';
    JobName : string = this.i + 'JobName';
    EstimatedStartDate : string = this.i + 'EstimatedStartDate';
    EstimatedEndDate : string = this.i + 'EstimatedEndDate';
    ProjectMgr1UserId : string = this.i + 'ProjectMgr1UserId';
    ProjectMgr2UserId : string = this.i + 'ProjectMgr2UserId';
    AsstProjectMgrUserId : string = this.i + 'AsstProjectMgrUserId';
    SeniorMgrUserId : string = this.i + 'SeniorMgrUserId';
    LeadTech1UserId : string = this.i + 'LeadTech1UserId';
    LeadTech2UserId : string = this.i + 'LeadTech2UserId';
    InvoiceApproval1UserId : string = this.i + 'InvoiceApproval1UserId';
    InvoiceApproval2UserId : string = this.i + 'InvoiceApproval2UserId';
    ForecastStatusCv : string = this.i + 'ForecastStatusCv';
    ForecastStatus : string = this.i + 'ForecastStatus';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CustomerName : string = this.i + 'CustomerName';
    CustomerShortName : string = this.i + 'CustomerShortName';
    BillingInstructions : string = this.i + 'BillingInstructions';
    ChangeOrderProcessInstructions : string = this.i + 'ChangeOrderProcessInstructions';
    PartialBilling : string = this.i + 'PartialBilling';
    FinalInvoiceDate : string = this.i + 'FinalInvoiceDate';
    InvoiceDeliveryTypeData : string = this.i + 'InvoiceDeliveryTypeData';
    InvoiceDeliveryTypeCV : string = this.i + 'InvoiceDeliveryTypeCV';
    OpportunityId : string = this.i + 'OpportunityId';
    EndCustomerId : string = this.i + 'EndCustomerId';
    LookUpKey : string = this.i + 'LookUpKey';
    IsDeleted : string = this.i + 'IsDeleted';
    JobNumberTypeCv : string = this.i + 'JobNumberTypeCv';

    Relations = {
            /** Relation: Ethos User - Project Mgr1 User */
            EthosUserByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosUser',
                PropertyName: 'ProjectMgr1EthosUser'
            },
            /** Relation: Ethos User - Project Mgr2 User */
            EthosUserByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosUser',
                PropertyName: 'ProjectMgr2EthosUser'
            },
            /** Relation: Ethos User - Asst Project Mgr User */
            EthosUserByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosUser',
                PropertyName: 'AsstProjectMgrEthosUser'
            },
            /** Relation: Ethos User - Senior Mgr User */
            EthosUserBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosUser',
                PropertyName: 'SeniorMgrEthosUser'
            },
            /** Relation: Ethos User - Lead Tech1 User */
            EthosUserByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosUser',
                PropertyName: 'LeadTech1EthosUser'
            },
            /** Relation: Ethos User - Lead Tech2 User */
            EthosUserByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosUser',
                PropertyName: 'LeadTech2EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval1 User */
            EthosUserByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosUser',
                PropertyName: 'InvoiceApproval1EthosUser'
            },
            /** Relation: Ethos User - Invoice Approval2 User */
            EthosUserByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosUser',
                PropertyName: 'InvoiceApproval2EthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Job Number Forecast */
            EthosJobNumberForecast : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumberForecast',
                PropertyName: 'EthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Phase */
            EthosJobNumberPhase : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumberPhase',
                PropertyName: 'EthosJobNumberPhase'
            },
            /** Relation: Ethos Job Number Priority */
            EthosJobNumberPriority : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumberPriority',
                PropertyName: 'EthosJobNumberPriority'
            },
            /** Relation: Ethos User - Project Mgr1 User - Many */
            EthosUserByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosUser',
                PropertyName: 'UserIdEthosUser'
            },
            /** Relation: Wachter Team - Overhead - Many */
            EthosWachterTeamByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
            /** Relation: Overhead Projection */
            OverheadProjection : {
                RelationName: 'Ethos_JobNumber|OverheadProjection|JobNumberId',
                FieldPrefix: 'OverheadProjection',
                PropertyName: 'OverheadProjection'
            },
            /** Relation: Overhead Team Phase */
            OverheadTeamPhase : {
                RelationName: 'Ethos_JobNumber|OverheadTeamPhase|JobNumberId',
                FieldPrefix: 'OverheadTeamPhase',
                PropertyName: 'OverheadTeamPhase'
            },
    };
}

export class EthosJobNumberForecastMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberForecast.';

    constructor() {
        this.ItemDetail.ItemId=2374;
        this.ItemDetail.ItemName='Ethos_JobNumberForecast';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberForecastId : string = this.i + 'JobNumberForecastId';
    JobNumberId : string = this.i + 'JobNumberId';
    YeProjectedCosts : string = this.i + 'YeProjectedCosts';
    YeProjectedRevenue : string = this.i + 'YeProjectedRevenue';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedBy : string = this.i + 'ModifiedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    Notes : string = this.i + 'Notes';
    NoteAgingOverSixtyDays : string = this.i + 'NoteAgingOverSixtyDays';
    NoteOverUnderBilling : string = this.i + 'NoteOverUnderBilling';
    NoteLowForecastedGpm : string = this.i + 'NoteLowForecastedGpm';
    NoteChangedGpm : string = this.i + 'NoteChangedGpm';
    AXIntegrationID : string = this.i + 'AXIntegrationID';
    TotalForecastRevenue : string = this.i + 'TotalForecastRevenue';
    TotalForecastCost : string = this.i + 'TotalForecastCost';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberForecast|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By */
            EthosUserByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By */
            EthosUserByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
    };
}

export class EthosJobNumberMembershipMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberMembership.';

    constructor() {
        this.ItemDetail.ItemId=2794;
        this.ItemDetail.ItemName='Ethos_JobNumberMembership';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberMembershipId : string = this.i + 'JobNumberMembershipId';
    UserId : string = this.i + 'UserId';
    JobNumberId : string = this.i + 'JobNumberId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberMembership|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosJobNumberPhaseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPhase.';

    constructor() {
        this.ItemDetail.ItemId=2552;
        this.ItemDetail.ItemName='Ethos_JobNumberPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPhaseId : string = this.i + 'JobNumberPhaseId';
    JobNumberId : string = this.i + 'JobNumberId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    IsVisible : string = this.i + 'IsVisible';
    IsOnSite : string = this.i + 'IsOnSite';
    IsEstimate : string = this.i + 'IsEstimate';
    JobNumberPhaseStatusWs : string = this.i + 'JobNumberPhaseStatusWs';
    WorkflowStatusDisplay : string = this.i + 'WorkflowStatusDisplay';
    LookUpKey : string = this.i + 'LookUpKey';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Wachter Team - Job Number Phase - Many */
            EthosWachterTeamByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosWachterTeam',
                PropertyName: 'OverheadEthosWachterTeam'
            },
    };
}

export class EthosJobNumberPriorityMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_JobNumberPriority.';

    constructor() {
        this.ItemDetail.ItemId=2792;
        this.ItemDetail.ItemName='Ethos_JobNumberPriority';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    JobNumberPriorityId : string = this.i + 'JobNumberPriorityId';
    JobNumberId : string = this.i + 'JobNumberId';
    PriorityName : string = this.i + 'PriorityName';
    IsDeleted : string = this.i + 'IsDeleted';
    ResponseTimeInHours : string = this.i + 'ResponseTimeInHours';
    StraightHourlyBillingRate : string = this.i + 'StraightHourlyBillingRate';
    OvertimeHourlyBillingRate : string = this.i + 'OvertimeHourlyBillingRate';
    HolidayHourlyBillingRate : string = this.i + 'HolidayHourlyBillingRate';
    TravelHourlyBillingRate : string = this.i + 'TravelHourlyBillingRate';
    MileageBillingRate : string = this.i + 'MileageBillingRate';
    MaxTravelInHours : string = this.i + 'MaxTravelInHours';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedByUserId : string = this.i + 'CreatedByUserId';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedByUserId : string = this.i + 'ModifiedByUserId';
    TripCharge : string = this.i + 'TripCharge';
    ExpediteFee : string = this.i + 'ExpediteFee';
    IsEscalationEnabled : string = this.i + 'IsEscalationEnabled';
    SendPriorityNotification : string = this.i + 'SendPriorityNotification';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|Ethos_JobNumberPriority|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Created By User */
            EthosUserByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosUser',
                PropertyName: 'CreatedByEthosUser'
            },
            /** Relation: Ethos User - Modified By User */
            EthosUserByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosUser',
                PropertyName: 'ModifiedByEthosUser'
            },
    };
}

export class EthosRoUserLaborSummaryMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_roUserLaborSummary.';

    constructor() {
        this.ItemDetail.ItemId=2793;
        this.ItemDetail.ItemName='Ethos_roUserLaborSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    YTDAvgWeeklyHrs : string = this.i + 'YTD_AvgWeeklyHrs';
    Last12MonthsAvgWeeklyHrs : string = this.i + 'Last12Months_AvgWeeklyHrs';
    LastMonthAvgWeeklyHrs : string = this.i + 'LastMonth_AvgWeeklyHrs';
    LastWeekHrs : string = this.i + 'LastWeek_Hrs';
    ThisWeekHrs : string = this.i + 'ThisWeek_Hrs';

    Relations = {
    };
}

export class EthosServiceUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_ServiceUser.';

    constructor() {
        this.ItemDetail.ItemId=2676;
        this.ItemDetail.ItemName='Ethos_ServiceUser';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosServiceUserId : string = this.i + 'EthosServiceUserId';
    EthosUserId : string = this.i + 'Ethos_UserId';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_ServiceUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: Job Number - User Id */
            EthosJobNumberByUserId : {
                RelationName: 'JobNumber->ProjectManager',
                FieldPrefix: 'UserIdEthosJobNumber',
                PropertyName: 'UserIdEthosJobNumber'
            },
            /** Relation: Ethos User - Supervisor User - One */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: Emulation User - Emulate - Many */
            EmaulationUserByEmulateEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|EmulateEthos_UserId',
                FieldPrefix: 'EmulateEthosEmaulationUser',
                PropertyName: 'EmulateEthosEmaulationUser'
            },
            /** Relation: Emulation User - Many */
            EmaulationUserByEthosUserId : {
                RelationName: 'Ethos_User|EmaulationUser|Ethos_UserId',
                FieldPrefix: 'EthosEmaulationUser',
                PropertyName: 'EthosEmaulationUser'
            },
            /** Relation: Job Number - Project Mgr1 - Many */
            EthosJobNumberByProjectMgr1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr1UserId',
                FieldPrefix: 'ProjectMgr1EthosJobNumber',
                PropertyName: 'ProjectMgr1EthosJobNumber'
            },
            /** Relation: Job Number - Project Mgr2 - Many */
            EthosJobNumberByProjectMgr2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|ProjectMgr2UserId',
                FieldPrefix: 'ProjectMgr2EthosJobNumber',
                PropertyName: 'ProjectMgr2EthosJobNumber'
            },
            /** Relation: Job Number - Asst Project Mgr - Many */
            EthosJobNumberByAsstProjectMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|AsstProjectMgrUserId',
                FieldPrefix: 'AsstProjectMgrEthosJobNumber',
                PropertyName: 'AsstProjectMgrEthosJobNumber'
            },
            /** Relation: Job Number - Senior Mgr - Many */
            EthosJobNumberBySeniorMgrUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|SeniorMgrUserId',
                FieldPrefix: 'SeniorMgrEthosJobNumber',
                PropertyName: 'SeniorMgrEthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech1 - Many */
            EthosJobNumberByLeadTech1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech1UserId',
                FieldPrefix: 'LeadTech1EthosJobNumber',
                PropertyName: 'LeadTech1EthosJobNumber'
            },
            /** Relation: Job Number - Lead Tech2 - Many */
            EthosJobNumberByLeadTech2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|LeadTech2UserId',
                FieldPrefix: 'LeadTech2EthosJobNumber',
                PropertyName: 'LeadTech2EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval1 - Many */
            EthosJobNumberByInvoiceApproval1UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval1UserId',
                FieldPrefix: 'InvoiceApproval1EthosJobNumber',
                PropertyName: 'InvoiceApproval1EthosJobNumber'
            },
            /** Relation: Job Number - Invoice Approval2 - Many */
            EthosJobNumberByInvoiceApproval2UserId : {
                RelationName: 'Ethos_User|Ethos_JobNumber|InvoiceApproval2UserId',
                FieldPrefix: 'InvoiceApproval2EthosJobNumber',
                PropertyName: 'InvoiceApproval2EthosJobNumber'
            },
            /** Relation: Job Number Forecast - Created By - Many */
            EthosJobNumberForecastByCreatedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|CreatedBy',
                FieldPrefix: 'CreatedByEthosJobNumberForecast',
                PropertyName: 'CreatedByEthosJobNumberForecast'
            },
            /** Relation: Job Number Forecast - Modified By - Many */
            EthosJobNumberForecastByModifiedBy : {
                RelationName: 'Ethos_User|Ethos_JobNumberForecast|ModifiedBy',
                FieldPrefix: 'ModifiedByEthosJobNumberForecast',
                PropertyName: 'ModifiedByEthosJobNumberForecast'
            },
            /** Relation: Ethos Job Number Membership */
            EthosJobNumberMembership : {
                RelationName: 'Ethos_User|Ethos_JobNumberMembership|UserId',
                FieldPrefix: 'EthosJobNumberMembership',
                PropertyName: 'EthosJobNumberMembership'
            },
            /** Relation: Ethos Job Number Priority - Created By - Many */
            EthosJobNumberPriorityByCreatedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|CreatedByUserId',
                FieldPrefix: 'CreatedByEthosJobNumberPriority',
                PropertyName: 'CreatedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Job Number Priority - Modified By - Many */
            EthosJobNumberPriorityByModifiedByUserId : {
                RelationName: 'Ethos_User|Ethos_JobNumberPriority|ModifiedByUserId',
                FieldPrefix: 'ModifiedByEthosJobNumberPriority',
                PropertyName: 'ModifiedByEthosJobNumberPriority'
            },
            /** Relation: Ethos Service User - Many */
            EthosServiceUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_ServiceUser|Ethos_UserId',
                FieldPrefix: 'EthosEthosServiceUser',
                PropertyName: 'EthosEthosServiceUser'
            },
            /** Relation: Ethos User Diff - Many */
            EthosUserDiffByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUserDiff',
                PropertyName: 'EthosEthosUserDiff'
            },
            /** Relation: User Skill */
            EthosUserSkill : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUserSkill',
                PropertyName: 'EthosUserSkill'
            },
            /** Relation: Wachter Team - Team Leader - Many */
            EthosWachterTeamByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosWachterTeam',
                PropertyName: 'TeamLeaderEthosWachterTeam'
            },
            /** Relation: Overhead Projection - Modified By - Many */
            OverheadProjectionByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosOverheadProjection',
                PropertyName: 'ModifiedByEthosOverheadProjection'
            },
            /** Relation: Overhead Projection - Created By - Many */
            OverheadProjectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOverheadProjection',
                PropertyName: 'CreatedByEthosOverheadProjection'
            },
            /** Relation: Overhead Team Phase - Modified By - Many */
            OverheadTeamPhaseByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosOverheadTeamPhase',
                PropertyName: 'ModifiedByEthosOverheadTeamPhase'
            },
            /** Relation: Overhead Team Phase - Created By - Many */
            OverheadTeamPhaseByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosOverheadTeamPhase',
                PropertyName: 'CreatedByEthosOverheadTeamPhase'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Ro Ethos User - Supervisor - Many */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Trust User Merged - New  - Many */
            TrustUserMergedByNewUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|New_UserId',
                FieldPrefix: 'NewTrustUserMerged',
                PropertyName: 'NewTrustUserMerged'
            },
            /** Relation: Trust User Merged - Old  - Many */
            TrustUserMergedByOldUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|Old_UserId',
                FieldPrefix: 'OldTrustUserMerged',
                PropertyName: 'OldTrustUserMerged'
            },
            /** Relation: User Extended - Many */
            UserExtendedByEthosUserId : {
                RelationName: 'Ethos_User|UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosUserExtended',
                PropertyName: 'EthosUserExtended'
            },
            /** Relation: User Projection - Modified By - Many */
            WcUserProjectionByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosWcUserProjection',
                PropertyName: 'ModifiedByEthosWcUserProjection'
            },
            /** Relation: User Projection - Created By - Many */
            WcUserProjectionByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosWcUserProjection',
                PropertyName: 'CreatedByEthosWcUserProjection'
            },
            /** Relation: User Projection - Many */
            WcUserProjectionByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|Ethos_UserId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
    };
}

export class EthosUserDiffMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|Ethos_UserDiff|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class EthosUserSkillMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Meaning : string = this.i + 'Meaning';
    Display : string = this.i + 'Display';

    Relations = {
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|Ethos_UserSkill|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
    };
}

export class EthosWachterTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterTeam.';

    constructor() {
        this.ItemDetail.ItemId=2412;
        this.ItemDetail.ItemName='Ethos_WachterTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamTypeCv : string = this.i + 'TeamTypeCv';
    TeamTypeMeaning : string = this.i + 'TeamTypeMeaning';
    TeamName : string = this.i + 'TeamName';
    TeamLeaderUserId : string = this.i + 'TeamLeaderUserId';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    IsDeleted : string = this.i + 'IsDeleted';
    OverheadJobNumberId : string = this.i + 'OverheadJobNumberId';
    OverheadJobNumberPhaseId : string = this.i + 'OverheadJobNumberPhaseId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';

    Relations = {
            /** Relation: Job Number - Overhead Job Number */
            EthosJobNumberByOverheadJobNumberId : {
                RelationName: 'Ethos_JobNumber|Ethos_WachterTeam|OverheadJobNumberId',
                FieldPrefix: 'OverheadEthosJobNumber',
                PropertyName: 'OverheadEthosJobNumber'
            },
            /** Relation: Ethos Job Number Phase - Overhead Job Number Phase */
            EthosJobNumberPhaseByOverheadJobNumberPhaseId : {
                RelationName: 'Ethos_JobNumberPhase|Ethos_WachterTeam|OverheadJobNumberPhaseId',
                FieldPrefix: 'OverheadEthosJobNumberPhase',
                PropertyName: 'OverheadEthosJobNumberPhase'
            },
            /** Relation: Ethos User - Team Leader User */
            EthosUserByTeamLeaderUserId : {
                RelationName: 'Ethos_User|Ethos_WachterTeam|TeamLeaderUserId',
                FieldPrefix: 'TeamLeaderEthosUser',
                PropertyName: 'TeamLeaderEthosUser'
            },
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'JobNumber|WachterTeam|WachterTeamId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_WachterTeam|Ethos_User|WachterTeamId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ro Ethos User */
            RoEthosUser : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'RoEthosUser',
                PropertyName: 'RoEthosUser'
            },
            /** Relation: Team Year Numbers - Ethos Team - Many */
            TeamYearNumbersByEthosTeamId : {
                RelationName: 'TeamYearNumbers_WachterTeam_WachterTeamId',
                FieldPrefix: 'EthosTeamIdTeamYearNumbers',
                PropertyName: 'EthosTeamIdTeamYearNumbers'
            },
            /** Relation: User Projection - Many */
            WcUserProjectionByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|wc_UserProjection|Ethos_WachterTeamId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
            /** Relation: User Team Lookup - Team - Many */
            UserTeamLookupByTeamId : {
                RelationName: 'Ethos_WachterTeam|UserTeamLookup|TeamId',
                FieldPrefix: 'TeamIdUserTeamLookup',
                PropertyName: 'TeamIdUserTeamLookup'
            },
            /** Relation: User Year Numbers */
            UserYearNumbers : {
                RelationName: 'Ethos_WachterTeam|UserYearNumbers|WachterTeamId',
                FieldPrefix: 'UserYearNumbers',
                PropertyName: 'UserYearNumbers'
            },
    };
}

export class OverheadProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OverheadProjection.';

    constructor() {
        this.ItemDetail.ItemId=2514;
        this.ItemDetail.ItemName='OverheadProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    FiscalYear : string = this.i + 'FiscalYear';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    Hours : string = this.i + 'Hours';
    Notes : string = this.i + 'Notes';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|OverheadProjection|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class OverheadTeamPhaseMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'OverheadTeamPhase.';

    constructor() {
        this.ItemDetail.ItemId=2515;
        this.ItemDetail.ItemName='OverheadTeamPhase';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadTeamPhaseId : string = this.i + 'OverheadTeamPhaseId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    FiscalYear : string = this.i + 'FiscalYear';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsActive : string = this.i + 'IsActive';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    OrganizationalEntityId : string = this.i + 'OrganizationalEntityId';

    Relations = {
            /** Relation: Job Number */
            EthosJobNumber : {
                RelationName: 'Ethos_JobNumber|OverheadTeamPhase|JobNumberId',
                FieldPrefix: 'EthosJobNumber',
                PropertyName: 'EthosJobNumber'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|OverheadTeamPhase|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
    };
}

export class RoEthosUserMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';
    YrsService : string = this.i + 'YrsService';
    StaffingAgencyName : string = this.i + 'StaffingAgencyName';

    Relations = {
            /** Relation: Ro Ethos User - Supervisor User - One */
            RoEthosUserBySupervisorUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId',
                FieldPrefix: 'SupervisorRoEthosUser',
                PropertyName: 'SupervisorRoEthosUser'
            },
            /** Relation: Ethos User */
            EthosUser : {
                RelationName: 'Ethos_User|roEthos_User|UserId',
                FieldPrefix: 'EthosUser',
                PropertyName: 'EthosUser'
            },
            /** Relation: Ethos User - Supervisor User */
            EthosUserBySupervisorUserId : {
                RelationName: 'Ethos_User|roEthos_User|SupervisorUserId',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|roEthos_User|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
            /** Relation: User Projection - Ethos  - Many */
            WcUserProjectionByEthosUserId : {
                RelationName: 'roEthos_User|wc_UserProjection|UserId',
                FieldPrefix: 'EthosWcUserProjection',
                PropertyName: 'EthosWcUserProjection'
            },
            /** Relation: User Year Numbers - Ethos  - Many */
            UserYearNumbersByEthosUserId : {
                RelationName: 'UserYearNumbers_EthosUser',
                FieldPrefix: 'EthosUserYearNumbers',
                PropertyName: 'EthosUserYearNumbers'
            },
    };
}

export class RoEthosUserOriginalMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_UserOriginal.';

    constructor() {
        this.ItemDetail.ItemId=2661;
        this.ItemDetail.ItemName='roEthos_UserOriginal';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    AXId : string = this.i + 'AXId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    EmployeeType : string = this.i + 'EmployeeType';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsActive : string = this.i + 'IsActive';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceId : string = this.i + 'StateProvinceId';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';

    Relations = {
    };
}

export class RoEthosTeamsAndOrganizationalUnitsMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthosTeamsAndOrganizationalUnits.';

    constructor() {
        this.ItemDetail.ItemId=2387;
        this.ItemDetail.ItemName='roEthosTeamsAndOrganizationalUnits';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    TeamName : string = this.i + 'TeamName';
    IsTeam : string = this.i + 'IsTeam';

    Relations = {
    };
}

export class RoNspCommittedByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspCommittedByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2544;
        this.ItemDetail.ItemName='roNspCommittedByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspDwFinancialsByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwFinancialsByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2535;
        this.ItemDetail.ItemName='roNspDwFinancialsByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    YearCategory : string = this.i + 'YearCategory';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    HasRevenue : string = this.i + 'HasRevenue';
    FcRevJtd : string = this.i + 'fcRev_Jtd';
    FcCostJtd : string = this.i + 'fcCost_Jtd';
    RevenueYtd : string = this.i + 'Revenue_Ytd';
    RevenueJtd : string = this.i + 'Revenue_Jtd';
    PcRevenueYtd : string = this.i + 'pcRevenue_Ytd';
    PcRevenueJtd : string = this.i + 'pcRevenue_Jtd';
    CostYtd : string = this.i + 'Cost_Ytd';
    CostJtd : string = this.i + 'Cost_Jtd';
    OverheadYtd : string = this.i + 'Overhead_Ytd';
    OverheadJtd : string = this.i + 'Overhead_Jtd';

    Relations = {
    };
}

export class RoNspDwOverheadByDepartmentByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwOverheadByDepartmentByYear.';

    constructor() {
        this.ItemDetail.ItemId=2524;
        this.ItemDetail.ItemName='roNspDwOverheadByDepartmentByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    DepartmentId : string = this.i + 'DepartmentId';
    OverheadYtd : string = this.i + 'Overhead_Ytd';

    Relations = {
    };
}

export class RoNspDwOverheadByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspDwOverheadByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2533;
        this.ItemDetail.ItemName='roNspDwOverheadByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    Year : string = this.i + 'Year';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    OverheadYtd : string = this.i + 'Overhead_Ytd';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2541;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    UnitName : string = this.i + 'UnitName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';
    SubUnitName : string = this.i + 'SubUnitName';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearBackupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYear_Backup.';

    constructor() {
        this.ItemDetail.ItemId=2754;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYear_Backup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    UnitName : string = this.i + 'UnitName';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';

    Relations = {
    };
}

export class RoNspFinancialNumbersByTeamByYearOLDMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspFinancialNumbersByTeamByYearOLD.';

    constructor() {
        this.ItemDetail.ItemId=2681;
        this.ItemDetail.ItemName='roNspFinancialNumbersByTeamByYearOLD';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedFiscalYear : string = this.i + 'CommittedFiscalYear';
    CommittedTeamRevenue : string = this.i + 'CommittedTeamRevenue';
    CommittedTeamCost : string = this.i + 'CommittedTeamCost';
    CommittedTeamOverhead : string = this.i + 'CommittedTeamOverhead';
    CommittedUnitRevenue : string = this.i + 'CommittedUnitRevenue';
    CommittedUnitCost : string = this.i + 'CommittedUnitCost';
    CommittedUnitPercentage : string = this.i + 'CommittedUnitPercentage';
    CommittedUnitOverhead : string = this.i + 'CommittedUnitOverhead';
    CommittedDepartmentRevenue : string = this.i + 'CommittedDepartmentRevenue';
    CommittedDepartmentCost : string = this.i + 'CommittedDepartmentCost';
    CommittedDepartmentPercentage : string = this.i + 'CommittedDepartmentPercentage';
    CommittedDepartmentOverhead : string = this.i + 'CommittedDepartmentOverhead';
    CommittedTeamGrossProfit : string = this.i + 'CommittedTeamGrossProfit';
    CommittedTeamNetProfit : string = this.i + 'CommittedTeamNetProfit';
    CommittedTeamGrossProfitMargin : string = this.i + 'CommittedTeamGrossProfitMargin';
    CommittedTeamNetProfitMargin : string = this.i + 'CommittedTeamNetProfitMargin';
    ProjectedFiscalYear : string = this.i + 'ProjectedFiscalYear';
    ProjectedTeamRevenue : string = this.i + 'ProjectedTeamRevenue';
    ProjectedTeamCost : string = this.i + 'ProjectedTeamCost';
    ProjectedTeamOverhead : string = this.i + 'ProjectedTeamOverhead';
    ProjectedUnitRevenue : string = this.i + 'ProjectedUnitRevenue';
    ProjectedUnitCost : string = this.i + 'ProjectedUnitCost';
    ProjectedUnitPercentage : string = this.i + 'ProjectedUnitPercentage';
    ProjectedUnitOverhead : string = this.i + 'ProjectedUnitOverhead';
    ProjectedDepartmentRevenue : string = this.i + 'ProjectedDepartmentRevenue';
    ProjectedDepartmentCost : string = this.i + 'ProjectedDepartmentCost';
    ProjectedDepartmentPercentage : string = this.i + 'ProjectedDepartmentPercentage';
    ProjectedDepartmentOverhead : string = this.i + 'ProjectedDepartmentOverhead';
    ProjectedTeamGrossProfit : string = this.i + 'ProjectedTeamGrossProfit';
    ProjectedTeamNetProfit : string = this.i + 'ProjectedTeamNetProfit';
    ProjectedTeamGrossProfitMargin : string = this.i + 'ProjectedTeamGrossProfitMargin';
    ProjectedTeamNetProfitMargin : string = this.i + 'ProjectedTeamNetProfitMargin';
    YtdFiscalYear : string = this.i + 'YtdFiscalYear';
    YtdTeamRevenue : string = this.i + 'YtdTeamRevenue';
    YtdTeamCost : string = this.i + 'YtdTeamCost';
    YtdTeamOverhead : string = this.i + 'YtdTeamOverhead';
    YtdUnitRevenue : string = this.i + 'YtdUnitRevenue';
    YtdUnitCost : string = this.i + 'YtdUnitCost';
    YtdUnitPercentage : string = this.i + 'YtdUnitPercentage';
    YtdUnitOverhead : string = this.i + 'YtdUnitOverhead';
    YtdDepartmentRevenue : string = this.i + 'YtdDepartmentRevenue';
    YtdDepartmentCost : string = this.i + 'YtdDepartmentCost';
    YtdDepartmentPercentage : string = this.i + 'YtdDepartmentPercentage';
    YtdDepartmentOverhead : string = this.i + 'YtdDepartmentOverhead';
    YtdTeamGrossProfit : string = this.i + 'YtdTeamGrossProfit';
    YtdTeamNetProfit : string = this.i + 'YtdTeamNetProfit';
    YtdTeamGrossProfitMargin : string = this.i + 'YtdTeamGrossProfitMargin';
    YtdTeamNetProfitMargin : string = this.i + 'YtdTeamNetProfitMargin';
    PcFiscalYear : string = this.i + 'PcFiscalYear';
    PcTeamRevenue : string = this.i + 'PcTeamRevenue';
    PcTeamCost : string = this.i + 'PcTeamCost';
    PcTeamOverhead : string = this.i + 'PcTeamOverhead';
    PcUnitRevenue : string = this.i + 'PcUnitRevenue';
    PcUnitCost : string = this.i + 'PcUnitCost';
    PcUnitPercentage : string = this.i + 'PcUnitPercentage';
    PcUnitOverhead : string = this.i + 'PcUnitOverhead';
    PcDepartmentRevenue : string = this.i + 'PcDepartmentRevenue';
    PcDepartmentCost : string = this.i + 'PcDepartmentCost';
    PcDepartmentPercentage : string = this.i + 'PcDepartmentPercentage';
    PcDepartmentOverhead : string = this.i + 'PcDepartmentOverhead';
    PcTeamGrossProfit : string = this.i + 'PcTeamGrossProfit';
    PcTeamNetProfit : string = this.i + 'PcTeamNetProfit';
    PcTeamGrossProfitMargin : string = this.i + 'PcTeamGrossProfitMargin';
    PcTeamNetProfitMargin : string = this.i + 'PcTeamNetProfitMargin';
    ForecastedFiscalYear : string = this.i + 'ForecastedFiscalYear';
    ForecastedTeamRevenue : string = this.i + 'ForecastedTeamRevenue';
    ForecastedTeamCost : string = this.i + 'ForecastedTeamCost';
    ForecastedTeamOverhead : string = this.i + 'ForecastedTeamOverhead';
    ForecastedUnitRevenue : string = this.i + 'ForecastedUnitRevenue';
    ForecastedUnitCost : string = this.i + 'ForecastedUnitCost';
    ForecastedUnitPercentage : string = this.i + 'ForecastedUnitPercentage';
    ForecastedUnitOverhead : string = this.i + 'ForecastedUnitOverhead';
    ForecastedDepartmentRevenue : string = this.i + 'ForecastedDepartmentRevenue';
    ForecastedDepartmentCost : string = this.i + 'ForecastedDepartmentCost';
    ForecastedDepartmentPercentage : string = this.i + 'ForecastedDepartmentPercentage';
    ForecastedDepartmentOverhead : string = this.i + 'ForecastedDepartmentOverhead';
    ForecastedTeamGrossProfit : string = this.i + 'ForecastedTeamGrossProfit';
    ForecastedTeamNetProfit : string = this.i + 'ForecastedTeamNetProfit';
    ForecastedTeamGrossProfitMargin : string = this.i + 'ForecastedTeamGrossProfitMargin';
    ForecastedTeamNetProfitMargin : string = this.i + 'ForecastedTeamNetProfitMargin';

    Relations = {
    };
}

export class RoNspOverheadProjectedByDepartmentByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspOverheadProjectedByDepartmentByYear.';

    constructor() {
        this.ItemDetail.ItemId=2539;
        this.ItemDetail.ItemName='roNspOverheadProjectedByDepartmentByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    FiscalYear : string = this.i + 'FiscalYear';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspOverheadProjectedByTeamByYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspOverheadProjectedByTeamByYear.';

    constructor() {
        this.ItemDetail.ItemId=2547;
        this.ItemDetail.ItemName='roNspOverheadProjectedByTeamByYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    OrganizationalUnitId : string = this.i + 'OrganizationalUnitId';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoNspProjectedByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roNspProjectedByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2540;
        this.ItemDetail.ItemName='roNspProjectedByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    TeamId : string = this.i + 'TeamId';
    UnitId : string = this.i + 'UnitId';
    DepartmentId : string = this.i + 'DepartmentId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';

    Relations = {
    };
}

export class RoOrganizationalTeamUnitDeptMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOrganizationalTeamUnitDept.';

    constructor() {
        this.ItemDetail.ItemId=2530;
        this.ItemDetail.ItemName='roOrganizationalTeamUnitDept';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TeamId : string = this.i + 'TeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    DepartmentId : string = this.i + 'DepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';

    Relations = {
    };
}

export class RoOverheadCommittedByJobPhaseYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadCommittedByJobPhaseYear.';

    constructor() {
        this.ItemDetail.ItemId=2531;
        this.ItemDetail.ItemName='roOverheadCommittedByJobPhaseYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoOverheadProjectedByJobPhaseYearMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadProjectedByJobPhaseYear.';

    constructor() {
        this.ItemDetail.ItemId=2529;
        this.ItemDetail.ItemName='roOverheadProjectedByJobPhaseYear';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitName : string = this.i + 'TeamUnitName';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoOverheadProjectionByTeamMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roOverheadProjectionByTeam.';

    constructor() {
        this.ItemDetail.ItemId=2528;
        this.ItemDetail.ItemName='roOverheadProjectionByTeam';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    OverheadProjectionId : string = this.i + 'OverheadProjectionId';
    OrganizationalTeamId : string = this.i + 'OrganizationalTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    TeamUnitId : string = this.i + 'TeamUnitId';
    TeamUnitIsTeam : string = this.i + 'TeamUnitIsTeam';
    HasRevenue : string = this.i + 'HasRevenue';
    Cost : string = this.i + 'Cost';
    JobNumberId : string = this.i + 'JobNumberId';
    JobNumber : string = this.i + 'JobNumber';
    PhaseId : string = this.i + 'PhaseId';
    PhaseCode : string = this.i + 'PhaseCode';
    PhaseDescription : string = this.i + 'PhaseDescription';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoProjectManagersTeamUnitDeptMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roProjectManagersTeamUnitDept.';

    constructor() {
        this.ItemDetail.ItemId=2525;
        this.ItemDetail.ItemName='roProjectManagersTeamUnitDept';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    HasRevenue : string = this.i + 'HasRevenue';
    PMNameFirstPreferredLast : string = this.i + 'PMNameFirstPreferredLast';
    PMNameLastFirstPreferred : string = this.i + 'PMNameLastFirstPreferred';
    PMNameFirstLast : string = this.i + 'PMNameFirstLast';
    PMNamePreferredLast : string = this.i + 'PMNamePreferredLast';
    EthosTitle : string = this.i + 'EthosTitle';
    EthosEmail : string = this.i + 'EthosEmail';
    EthosSupId : string = this.i + 'EthosSupId';
    SupNameFirstPreferredLast : string = this.i + 'SupNameFirstPreferredLast';
    SupNameLastFirstPreferred : string = this.i + 'SupNameLastFirstPreferred';
    SupNameFirstLast : string = this.i + 'SupNameFirstLast';
    SupNamePreferredLast : string = this.i + 'SupNamePreferredLast';
    TeamId : string = this.i + 'TeamId';
    TeamName : string = this.i + 'TeamName';
    TeamOwnerId : string = this.i + 'TeamOwnerId';
    TeamOwnerFirstPreferredLast : string = this.i + 'TeamOwnerFirstPreferredLast';
    TeamOwnerLastFirstPreferred : string = this.i + 'TeamOwnerLastFirstPreferred';
    TeamOwnerFirstLast : string = this.i + 'TeamOwnerFirstLast';
    TeamOwnerPreferredLast : string = this.i + 'TeamOwnerPreferredLast';
    UnitId : string = this.i + 'UnitId';
    UnitName : string = this.i + 'UnitName';
    UnitOwnerId : string = this.i + 'UnitOwnerId';
    UnitOwnerFirstPreferedLast : string = this.i + 'UnitOwnerFirstPreferedLast';
    UnitOwnerLastFirstPrefered : string = this.i + 'UnitOwnerLastFirstPrefered';
    UnitOwnerFirstLast : string = this.i + 'UnitOwnerFirstLast';
    UnitOwnerPreferredLast : string = this.i + 'UnitOwnerPreferredLast';
    DepartmentId : string = this.i + 'DepartmentId';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentOwnerId : string = this.i + 'DepartmentOwnerId';
    DepartmentOwnerFirstPreferedLast : string = this.i + 'DepartmentOwnerFirstPreferedLast';
    DepartmentOwnerLastFirstPrefered : string = this.i + 'DepartmentOwnerLastFirstPrefered';
    DepartmentOwnerFirstLast : string = this.i + 'DepartmentOwnerFirstLast';
    DepartmentOwnerPreferedLast : string = this.i + 'DepartmentOwnerPreferedLast';

    Relations = {
    };
}

export class RoUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roUserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2506;
        this.ItemDetail.ItemName='roUserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    Cost : string = this.i + 'Cost';
    Revenue : string = this.i + 'Revenue';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    ProjectionMonth : string = this.i + 'ProjectionMonth';

    Relations = {
    };
}

export class NumbersRoUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'numbers_roUserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2553;
        this.ItemDetail.ItemName='numbers_roUserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    FiscalYear : string = this.i + 'FiscalYear';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ProjectedCost : string = this.i + 'ProjectedCost';
    ProjectedGP : string = this.i + 'ProjectedGP';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';

    Relations = {
    };
}

export class RoUserProjectionAnalyzedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roUserProjectionAnalyzed.';

    constructor() {
        this.ItemDetail.ItemId=3446;
        this.ItemDetail.ItemName='roUserProjectionAnalyzed';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    UserId : string = this.i + 'UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';
    Gross : string = this.i + 'Gross';
    GrossMargin : string = this.i + 'GrossMargin';
    DateTimeProjected : string = this.i + 'DateTimeProjected';
    DateTimeUtcAnalyzed : string = this.i + 'DateTimeUtcAnalyzed';

    Relations = {
    };
}

export class TeamYearNumbersMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TeamYearNumbers.';

    constructor() {
        this.ItemDetail.ItemId=2627;
        this.ItemDetail.ItemName='TeamYearNumbers';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosTeamId : string = this.i + 'EthosTeamId';
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedRevenue : string = this.i + 'CommittedRevenue';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ForecastedRevenue : string = this.i + 'ForecastedRevenue';
    ManagementRevenue : string = this.i + 'ManagementRevenue';
    CommittedGPM : string = this.i + 'CommittedGPM';
    CommittedNPM : string = this.i + 'CommittedNPM';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    ProjectedNPM : string = this.i + 'ProjectedNPM';
    ForecastedGPM : string = this.i + 'ForecastedGPM';
    ForecastedNPM : string = this.i + 'ForecastedNPM';
    ManagementGPM : string = this.i + 'ManagementGPM';
    ManagementNPM : string = this.i + 'ManagementNPM';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    AccountingRevenue : string = this.i + 'AccountingRevenue';
    AccountingGPM : string = this.i + 'AccountingGPM';
    AccountingNPM : string = this.i + 'AccountingNPM';
    CommittedNetProfit : string = this.i + 'CommittedNetProfit';
    ProjectedNetProfit : string = this.i + 'ProjectedNetProfit';
    ForecastedNetProfit : string = this.i + 'ForecastedNetProfit';
    AccountingNetProfit : string = this.i + 'AccountingNetProfit';
    ManagementNetProfit : string = this.i + 'ManagementNetProfit';

    Relations = {
            /** Relation: Wachter Team - Ethos Team */
            EthosWachterTeamByEthosTeamId : {
                RelationName: 'TeamYearNumbers_WachterTeam_WachterTeamId',
                FieldPrefix: 'EthosTeamIdEthosWachterTeam',
                PropertyName: 'EthosTeamIdEthosWachterTeam'
            },
    };
}

export class TrustUserMergedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'TrustUserMerged.';

    constructor() {
        this.ItemDetail.ItemId=2595;
        this.ItemDetail.ItemName='TrustUserMerged';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TrustUserMergedId : string = this.i + 'TrustUserMergedId';
    NewUserId : string = this.i + 'New_UserId';
    OldUserId : string = this.i + 'Old_UserId';

    Relations = {
            /** Relation: Ethos User - New User */
            EthosUserByNewUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|New_UserId',
                FieldPrefix: 'NewEthosUser',
                PropertyName: 'NewEthosUser'
            },
            /** Relation: Ethos User - Old User */
            EthosUserByOldUserId : {
                RelationName: 'Ethos_User|TrustUserMerged|Old_UserId',
                FieldPrefix: 'OldEthosUser',
                PropertyName: 'OldEthosUser'
            },
    };
}

export class UserExtendedMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserExtended.';

    constructor() {
        this.ItemDetail.ItemId=2361;
        this.ItemDetail.ItemName='UserExtended';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserExtendedId : string = this.i + 'UserExtendedId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FosEthosUserId : string = this.i + 'FosEthos_UserId';
    TerritoryId : string = this.i + 'TerritoryId';
    TechTypeCv : string = this.i + 'TechTypeCv';
    StartingPayRate : string = this.i + 'StartingPayRate';
    OrientationDate : string = this.i + 'OrientationDate';
    PermDate : string = this.i + 'PermDate';
    Comments : string = this.i + 'Comments';
    SpOsgAttachmentId : string = this.i + 'spOsgAttachmentId';
    IsPersonalVehicleUseAllowed : string = this.i + 'IsPersonalVehicleUseAllowed';
    PersonalVehicleUseExpirationDate : string = this.i + 'PersonalVehicleUseExpirationDate';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    HiringManagerEthosUserId : string = this.i + 'HiringManagerEthos_UserId';
    PayChangeDate : string = this.i + 'PayChangeDate';

    Relations = {
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|UserExtended|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
    };
}

export class WcUserProjectionMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'wc_UserProjection.';

    constructor() {
        this.ItemDetail.ItemId=2513;
        this.ItemDetail.ItemName='wc_UserProjection';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserProjectionId : string = this.i + 'UserProjectionId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FiscalYear : string = this.i + 'FiscalYear';
    EthosWachterTeamId : string = this.i + 'Ethos_WachterTeamId';
    Revenue : string = this.i + 'Revenue';
    Cost : string = this.i + 'Cost';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    GrossProfit : string = this.i + 'GrossProfit';
    GrossProfitMargin : string = this.i + 'GrossProfitMargin';

    Relations = {
            /** Relation: Ro Ethos User - Ethos User */
            RoEthosUserByEthosUserId : {
                RelationName: 'roEthos_User|wc_UserProjection|UserId',
                FieldPrefix: 'EthosRoEthosUser',
                PropertyName: 'EthosRoEthosUser'
            },
            /** Relation: Ethos User - Modified By Ethos User */
            EthosUserByModifiedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|ModifiedByEthos_UserId',
                FieldPrefix: 'ModifiedByEthosEthosUser',
                PropertyName: 'ModifiedByEthosEthosUser'
            },
            /** Relation: Ethos User - Created By Ethos User */
            EthosUserByCreatedByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|CreatedByEthos_UserId',
                FieldPrefix: 'CreatedByEthosEthosUser',
                PropertyName: 'CreatedByEthosEthosUser'
            },
            /** Relation: Ethos User - User */
            EthosUserByEthosUserId : {
                RelationName: 'Ethos_User|wc_UserProjection|Ethos_UserId',
                FieldPrefix: 'EthosEthosUser',
                PropertyName: 'EthosEthosUser'
            },
            /** Relation: Wachter Team - Ethos Wachter Team */
            EthosWachterTeamByEthosWachterTeamId : {
                RelationName: 'Ethos_WachterTeam|wc_UserProjection|Ethos_WachterTeamId',
                FieldPrefix: 'EthosEthosWachterTeam',
                PropertyName: 'EthosEthosWachterTeam'
            },
    };
}

export class UserTeamLookupMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserTeamLookup.';

    constructor() {
        this.ItemDetail.ItemId=2626;
        this.ItemDetail.ItemName='UserTeamLookup';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserId : string = this.i + 'Ethos_UserId';
    TeamId : string = this.i + 'TeamId';
    FiscalYear : string = this.i + 'FiscalYear';

    Relations = {
            /** Relation: Wachter Team - Team */
            EthosWachterTeamByTeamId : {
                RelationName: 'Ethos_WachterTeam|UserTeamLookup|TeamId',
                FieldPrefix: 'TeamIdEthosWachterTeam',
                PropertyName: 'TeamIdEthosWachterTeam'
            },
    };
}

export class UserYearNumbersMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'UserYearNumbers.';

    constructor() {
        this.ItemDetail.ItemId=2625;
        this.ItemDetail.ItemName='UserYearNumbers';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    FiscalYear : string = this.i + 'FiscalYear';
    CommittedRevenue : string = this.i + 'CommittedRevenue';
    ProjectedRevenue : string = this.i + 'ProjectedRevenue';
    ForecastedRevenue : string = this.i + 'ForecastedRevenue';
    ManagementRevenue : string = this.i + 'ManagementRevenue';
    CommittedGPM : string = this.i + 'CommittedGPM';
    CommittedNPM : string = this.i + 'CommittedNPM';
    ProjectedGPM : string = this.i + 'ProjectedGPM';
    ProjectedNPM : string = this.i + 'ProjectedNPM';
    ForecastedGPM : string = this.i + 'ForecastedGPM';
    ForecastedNPM : string = this.i + 'ForecastedNPM';
    ManagementGPM : string = this.i + 'ManagementGPM';
    ManagementNPM : string = this.i + 'ManagementNPM';
    EthosUserId : string = this.i + 'Ethos_UserId';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    AccountingRevenue : string = this.i + 'AccountingRevenue';
    AccountingGPM : string = this.i + 'AccountingGPM';
    AccountingNPM : string = this.i + 'AccountingNPM';
    WachterTeamId : string = this.i + 'WachterTeamId';
    CommittedNetProfit : string = this.i + 'CommittedNetProfit';
    ProjectedNetProfit : string = this.i + 'ProjectedNetProfit';
    ForecastedNetProfit : string = this.i + 'ForecastedNetProfit';
    AccountingNetProfit : string = this.i + 'AccountingNetProfit';
    ManagementNetProfit : string = this.i + 'ManagementNetProfit';

    Relations = {
            /** Relation: Ro Ethos User - Ethos User */
            RoEthosUserByEthosUserId : {
                RelationName: 'UserYearNumbers_EthosUser',
                FieldPrefix: 'EthosRoEthosUser',
                PropertyName: 'EthosRoEthosUser'
            },
            /** Relation: Wachter Team */
            EthosWachterTeam : {
                RelationName: 'Ethos_WachterTeam|UserYearNumbers|WachterTeamId',
                FieldPrefix: 'EthosWachterTeam',
                PropertyName: 'EthosWachterTeam'
            },
    };
}

export class WachterTeamDepartmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'WachterTeamDepartment.';

    constructor() {
        this.ItemDetail.ItemId=2485;
        this.ItemDetail.ItemName='WachterTeamDepartment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterTeamId : string = this.i + 'WachterTeamId';
    TeamName : string = this.i + 'TeamName';
    DepartmentName : string = this.i + 'DepartmentName';
    DivisionShortName : string = this.i + 'DivisionShortName';

    Relations = {
    };
}

export class NumbersMetaData {

    static EmaulationUser : EmaulationUserMetaData = new EmaulationUserMetaData();
    static EthosJobNumber : EthosJobNumberMetaData = new EthosJobNumberMetaData();
    static EthosJobNumberForecast : EthosJobNumberForecastMetaData = new EthosJobNumberForecastMetaData();
    static EthosJobNumberMembership : EthosJobNumberMembershipMetaData = new EthosJobNumberMembershipMetaData();
    static EthosJobNumberPhase : EthosJobNumberPhaseMetaData = new EthosJobNumberPhaseMetaData();
    static EthosJobNumberPriority : EthosJobNumberPriorityMetaData = new EthosJobNumberPriorityMetaData();
    static EthosRoUserLaborSummary : EthosRoUserLaborSummaryMetaData = new EthosRoUserLaborSummaryMetaData();
    static EthosServiceUser : EthosServiceUserMetaData = new EthosServiceUserMetaData();
    static EthosUser : EthosUserMetaData = new EthosUserMetaData();
    static EthosUserDiff : EthosUserDiffMetaData = new EthosUserDiffMetaData();
    static EthosUserSkill : EthosUserSkillMetaData = new EthosUserSkillMetaData();
    static EthosWachterTeam : EthosWachterTeamMetaData = new EthosWachterTeamMetaData();
    static OverheadProjection : OverheadProjectionMetaData = new OverheadProjectionMetaData();
    static OverheadTeamPhase : OverheadTeamPhaseMetaData = new OverheadTeamPhaseMetaData();
    static RoEthosUser : RoEthosUserMetaData = new RoEthosUserMetaData();
    static RoEthosUserOriginal : RoEthosUserOriginalMetaData = new RoEthosUserOriginalMetaData();
    static RoEthosTeamsAndOrganizationalUnits : RoEthosTeamsAndOrganizationalUnitsMetaData = new RoEthosTeamsAndOrganizationalUnitsMetaData();
    static RoNspCommittedByTeam : RoNspCommittedByTeamMetaData = new RoNspCommittedByTeamMetaData();
    static RoNspDwFinancialsByTeamByYear : RoNspDwFinancialsByTeamByYearMetaData = new RoNspDwFinancialsByTeamByYearMetaData();
    static RoNspDwOverheadByDepartmentByYear : RoNspDwOverheadByDepartmentByYearMetaData = new RoNspDwOverheadByDepartmentByYearMetaData();
    static RoNspDwOverheadByTeamByYear : RoNspDwOverheadByTeamByYearMetaData = new RoNspDwOverheadByTeamByYearMetaData();
    static RoNspFinancialNumbersByTeamByYear : RoNspFinancialNumbersByTeamByYearMetaData = new RoNspFinancialNumbersByTeamByYearMetaData();
    static RoNspFinancialNumbersByTeamByYearBackup : RoNspFinancialNumbersByTeamByYearBackupMetaData = new RoNspFinancialNumbersByTeamByYearBackupMetaData();
    static RoNspFinancialNumbersByTeamByYearOLD : RoNspFinancialNumbersByTeamByYearOLDMetaData = new RoNspFinancialNumbersByTeamByYearOLDMetaData();
    static RoNspOverheadProjectedByDepartmentByYear : RoNspOverheadProjectedByDepartmentByYearMetaData = new RoNspOverheadProjectedByDepartmentByYearMetaData();
    static RoNspOverheadProjectedByTeamByYear : RoNspOverheadProjectedByTeamByYearMetaData = new RoNspOverheadProjectedByTeamByYearMetaData();
    static RoNspProjectedByTeam : RoNspProjectedByTeamMetaData = new RoNspProjectedByTeamMetaData();
    static RoOrganizationalTeamUnitDept : RoOrganizationalTeamUnitDeptMetaData = new RoOrganizationalTeamUnitDeptMetaData();
    static RoOverheadCommittedByJobPhaseYear : RoOverheadCommittedByJobPhaseYearMetaData = new RoOverheadCommittedByJobPhaseYearMetaData();
    static RoOverheadProjectedByJobPhaseYear : RoOverheadProjectedByJobPhaseYearMetaData = new RoOverheadProjectedByJobPhaseYearMetaData();
    static RoOverheadProjectionByTeam : RoOverheadProjectionByTeamMetaData = new RoOverheadProjectionByTeamMetaData();
    static RoProjectManagersTeamUnitDept : RoProjectManagersTeamUnitDeptMetaData = new RoProjectManagersTeamUnitDeptMetaData();
    static RoUserProjection : RoUserProjectionMetaData = new RoUserProjectionMetaData();
    static NumbersRoUserProjection : NumbersRoUserProjectionMetaData = new NumbersRoUserProjectionMetaData();
    static RoUserProjectionAnalyzed : RoUserProjectionAnalyzedMetaData = new RoUserProjectionAnalyzedMetaData();
    static TeamYearNumbers : TeamYearNumbersMetaData = new TeamYearNumbersMetaData();
    static TrustUserMerged : TrustUserMergedMetaData = new TrustUserMergedMetaData();
    static UserExtended : UserExtendedMetaData = new UserExtendedMetaData();
    static WcUserProjection : WcUserProjectionMetaData = new WcUserProjectionMetaData();
    static UserTeamLookup : UserTeamLookupMetaData = new UserTeamLookupMetaData();
    static UserYearNumbers : UserYearNumbersMetaData = new UserYearNumbersMetaData();
    static WachterTeamDepartment : WachterTeamDepartmentMetaData = new WachterTeamDepartmentMetaData();
}
// Generated Entity Interfaces
export interface EmaulationUserEntity extends DwOrmData {
    // Attributes
    EmulationUserId?: number;
    Ethos_UserId?: number;
    EmulateEthos_UserId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    EmulateEthos_UserIdDisplay?: string;

    // Relations
    EmulateEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberEntity extends DwOrmData {
    // Attributes
    JobNumberId?: number;
    JobNumberStatusWs?: number;
    JobNumberStatus?: string;
    JobNumber?: string;
    CustomerId?: number;
    JobName?: string;
    EstimatedStartDate?: string;
    EstimatedEndDate?: string;
    ProjectMgr1UserId?: number;
    ProjectMgr2UserId?: number;
    AsstProjectMgrUserId?: number;
    SeniorMgrUserId?: number;
    LeadTech1UserId?: number;
    LeadTech2UserId?: number;
    InvoiceApproval1UserId?: number;
    InvoiceApproval2UserId?: number;
    ForecastStatusCv?: number;
    ForecastStatus?: string;
    WachterTeamId?: number;
    CustomerName?: string;
    CustomerShortName?: string;
    BillingInstructions?: string;
    ChangeOrderProcessInstructions?: string;
    PartialBilling?: boolean;
    FinalInvoiceDate?: string;
    InvoiceDeliveryTypeData?: string;
    InvoiceDeliveryTypeCV?: number;
    OpportunityId?: number;
    EndCustomerId?: number;
    LookUpKey?: number;
    IsDeleted?: boolean;
    JobNumberTypeCv?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberStatusWsDisplay?: string;
    CustomerIdDisplay?: string;
    ProjectMgr1UserIdDisplay?: string;
    ProjectMgr2UserIdDisplay?: string;
    AsstProjectMgrUserIdDisplay?: string;
    SeniorMgrUserIdDisplay?: string;
    LeadTech1UserIdDisplay?: string;
    LeadTech2UserIdDisplay?: string;
    InvoiceApproval1UserIdDisplay?: string;
    InvoiceApproval2UserIdDisplay?: string;
    ForecastStatusCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    InvoiceDeliveryTypeCVDisplay?: string;
    OpportunityIdDisplay?: string;
    EndCustomerIdDisplay?: string;
    JobNumberTypeCvDisplay?: string;

    // Relations
    ProjectMgr1EthosUser? : EthosUserEntity;
    ProjectMgr2EthosUser? : EthosUserEntity;
    AsstProjectMgrEthosUser? : EthosUserEntity;
    SeniorMgrEthosUser? : EthosUserEntity;
    LeadTech1EthosUser? : EthosUserEntity;
    LeadTech2EthosUser? : EthosUserEntity;
    InvoiceApproval1EthosUser? : EthosUserEntity;
    InvoiceApproval2EthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    EthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    EthosJobNumberPhase? : EthosJobNumberPhaseEntity[];
    EthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    UserIdEthosUser? : EthosUserEntity[];
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
    OverheadProjection? : OverheadProjectionEntity[];
    OverheadTeamPhase? : OverheadTeamPhaseEntity[];
}

export interface EthosJobNumberForecastEntity extends DwOrmData {
    // Attributes
    JobNumberForecastId?: number;
    JobNumberId?: number;
    YeProjectedCosts?: number;
    YeProjectedRevenue?: number;
    IsDeleted?: boolean;
    CreatedBy?: number;
    ModifiedBy?: number;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    Notes?: string;
    NoteAgingOverSixtyDays?: string;
    NoteOverUnderBilling?: string;
    NoteLowForecastedGpm?: string;
    NoteChangedGpm?: string;
    AXIntegrationID?: string;
    TotalForecastRevenue?: number;
    TotalForecastCost?: number;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByDisplay?: string;
    ModifiedByDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosJobNumberMembershipEntity extends DwOrmData {
    // Attributes
    JobNumberMembershipId?: number;
    UserId?: number;
    JobNumberId?: number;

    // Display Attributes
    UserIdDisplay?: string;
    JobNumberIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    EthosUser? : EthosUserEntity;
}

export interface EthosJobNumberPhaseEntity extends DwOrmData {
    // Attributes
    JobNumberPhaseId?: number;
    JobNumberId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    IsVisible?: boolean;
    IsOnSite?: boolean;
    IsEstimate?: boolean;
    JobNumberPhaseStatusWs?: number;
    WorkflowStatusDisplay?: string;
    LookUpKey?: number;

    // Display Attributes
    JobNumberIdDisplay?: string;
    JobNumberPhaseStatusWsDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    OverheadEthosWachterTeam? : EthosWachterTeamEntity[];
}

export interface EthosJobNumberPriorityEntity extends DwOrmData {
    // Attributes
    JobNumberPriorityId?: number;
    JobNumberId?: number;
    PriorityName?: string;
    IsDeleted?: boolean;
    ResponseTimeInHours?: number;
    StraightHourlyBillingRate?: number;
    OvertimeHourlyBillingRate?: number;
    HolidayHourlyBillingRate?: number;
    TravelHourlyBillingRate?: number;
    MileageBillingRate?: number;
    MaxTravelInHours?: number;
    CreatedDateTime?: string;
    CreatedByUserId?: number;
    ModifiedDateTime?: string;
    ModifiedByUserId?: number;
    TripCharge?: number;
    ExpediteFee?: number;
    IsEscalationEnabled?: boolean;
    SendPriorityNotification?: boolean;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByUserIdDisplay?: string;
    ModifiedByUserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    CreatedByEthosUser? : EthosUserEntity;
    ModifiedByEthosUser? : EthosUserEntity;
}

export interface EthosRoUserLaborSummaryEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    YTD_AvgWeeklyHrs?: number;
    Last12Months_AvgWeeklyHrs?: number;
    LastMonth_AvgWeeklyHrs?: number;
    LastWeek_Hrs?: number;
    ThisWeek_Hrs?: number;


    // Relations
}

export interface EthosServiceUserEntity extends DwOrmData {
    // Attributes
    EthosServiceUserId?: number;
    Ethos_UserId?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    isVaxxed?: boolean;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    CustomerIdDisplay?: string;

    // Relations
    UserIdEthosJobNumber? : EthosJobNumberEntity;
    SupervisorEthosUser? : EthosUserEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    EmulateEthosEmaulationUser? : EmaulationUserEntity[];
    EthosEmaulationUser? : EmaulationUserEntity[];
    ProjectMgr1EthosJobNumber? : EthosJobNumberEntity[];
    ProjectMgr2EthosJobNumber? : EthosJobNumberEntity[];
    AsstProjectMgrEthosJobNumber? : EthosJobNumberEntity[];
    SeniorMgrEthosJobNumber? : EthosJobNumberEntity[];
    LeadTech1EthosJobNumber? : EthosJobNumberEntity[];
    LeadTech2EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval1EthosJobNumber? : EthosJobNumberEntity[];
    InvoiceApproval2EthosJobNumber? : EthosJobNumberEntity[];
    CreatedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    ModifiedByEthosJobNumberForecast? : EthosJobNumberForecastEntity[];
    EthosJobNumberMembership? : EthosJobNumberMembershipEntity[];
    CreatedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    ModifiedByEthosJobNumberPriority? : EthosJobNumberPriorityEntity[];
    EthosEthosServiceUser? : EthosServiceUserEntity[];
    EthosEthosUserDiff? : EthosUserDiffEntity[];
    EthosUserSkill? : EthosUserSkillEntity[];
    TeamLeaderEthosWachterTeam? : EthosWachterTeamEntity[];
    ModifiedByEthosOverheadProjection? : OverheadProjectionEntity[];
    CreatedByEthosOverheadProjection? : OverheadProjectionEntity[];
    ModifiedByEthosOverheadTeamPhase? : OverheadTeamPhaseEntity[];
    CreatedByEthosOverheadTeamPhase? : OverheadTeamPhaseEntity[];
    RoEthosUser? : RoEthosUserEntity;
    SupervisorRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity[];
    NewTrustUserMerged? : TrustUserMergedEntity[];
    OldTrustUserMerged? : TrustUserMergedEntity[];
    EthosUserExtended? : UserExtendedEntity[];
    ModifiedByEthosWcUserProjection? : WcUserProjectionEntity[];
    CreatedByEthosWcUserProjection? : WcUserProjectionEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    Ethos_UserDiffId?: number;
    Ethos_UserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Meaning?: string;
    Display?: string;

    // Display Attributes
    UserIdDisplay?: string;
    SkillCvDisplay?: string;

    // Relations
    EthosUser? : EthosUserEntity;
}

export interface EthosWachterTeamEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamTypeCv?: number;
    TeamTypeMeaning?: string;
    TeamName?: string;
    TeamLeaderUserId?: number;
    AxIntegrationId?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    IsDeleted?: boolean;
    OverheadJobNumberId?: number;
    OverheadJobNumberPhaseId?: number;
    RowInsertDateTime?: string;

    // Display Attributes
    WachterDepartmentIdDisplay?: string;
    TeamTypeCvDisplay?: string;
    TeamLeaderUserIdDisplay?: string;
    OverheadJobNumberIdDisplay?: string;
    OverheadJobNumberPhaseIdDisplay?: string;

    // Relations
    OverheadEthosJobNumber? : EthosJobNumberEntity;
    OverheadEthosJobNumberPhase? : EthosJobNumberPhaseEntity;
    TeamLeaderEthosUser? : EthosUserEntity;
    EthosJobNumber? : EthosJobNumberEntity[];
    EthosUser? : EthosUserEntity[];
    RoEthosUser? : RoEthosUserEntity[];
    EthosTeamIdTeamYearNumbers? : TeamYearNumbersEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity[];
    TeamIdUserTeamLookup? : UserTeamLookupEntity[];
    UserYearNumbers? : UserYearNumbersEntity[];
}

export interface OverheadProjectionEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    FiscalYear?: number;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    Hours?: number;
    Notes?: string;

    // Display Attributes
    JobNumberIdDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface OverheadTeamPhaseEntity extends DwOrmData {
    // Attributes
    OverheadTeamPhaseId?: number;
    OrganizationalTeamId?: number;
    TeamUnitId?: number;
    TeamUnitIsTeam?: boolean;
    FiscalYear?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsActive?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    OrganizationalEntityId?: number;

    // Display Attributes
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;
    OrganizationalEntityIdDisplay?: string;

    // Relations
    EthosJobNumber? : EthosJobNumberEntity;
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;
    YrsService?: number;
    StaffingAgencyName?: string;

    // Display Attributes
    UserIdDisplay?: string;
    WachterJobTitleIdDisplay?: string;
    UserTypeCvDisplay?: string;
    StaffingAgencyIdDisplay?: string;
    ResourceGroupCvDisplay?: string;
    WachterTeamIdDisplay?: string;
    WachterDepartmentIdDisplay?: string;
    SupervisorUserIdDisplay?: string;
    UserStatusWsDisplay?: string;
    StateProvinceIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    SupervisorRoEthosUser? : RoEthosUserEntity;
    EthosUser? : EthosUserEntity;
    SupervisorEthosUser? : EthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
    // Duplicate property excluded
    // SupervisorRoEthosUser : RoEthosUserEntity[];
    EthosWcUserProjection? : WcUserProjectionEntity;
    EthosUserYearNumbers? : UserYearNumbersEntity[];
}

export interface RoEthosUserOriginalEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    AXId?: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    EmployeeType?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    empHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    BirthMonthDate?: string;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsActive?: number;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentFileKey?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceId?: number;
    StateProvinceShortName?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    SpecialInstructions?: string;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    Company?: number;
    LicenseCount?: number;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    NameLastFirstPreferedType?: string;


    // Relations
}

export interface RoEthosTeamsAndOrganizationalUnitsEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    TeamName?: string;
    IsTeam?: number;


    // Relations
}

export interface RoNspCommittedByTeamEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoNspDwFinancialsByTeamByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    YearCategory?: string;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    HasRevenue?: boolean;
    fcRev_Jtd?: number;
    fcCost_Jtd?: number;
    Revenue_Ytd?: number;
    Revenue_Jtd?: number;
    pcRevenue_Ytd?: number;
    pcRevenue_Jtd?: number;
    Cost_Ytd?: number;
    Cost_Jtd?: number;
    Overhead_Ytd?: number;
    Overhead_Jtd?: number;


    // Relations
}

export interface RoNspDwOverheadByDepartmentByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    DepartmentId?: number;
    Overhead_Ytd?: number;


    // Relations
}

export interface RoNspDwOverheadByTeamByYearEntity extends DwOrmData {
    // Attributes
    Year?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    TeamUnitIsTeam?: boolean;
    Overhead_Ytd?: number;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    UnitName?: string;
    WachterDepartmentId?: number;
    FiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfitMargin?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfitMargin?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamNetProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfitMargin?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcUnitOverhead?: number;
    PcDepartmentOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamNetProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfitMargin?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfitMargin?: number;
    SubUnitName?: string;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearBackupEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    UnitName?: string;
    WachterDepartmentId?: number;
    FiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamNetProfitMargin?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentOverhead?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamNetProfitMargin?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentOverhead?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfit?: number;
    YtdTeamNetProfitMargin?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentOverhead?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfit?: number;
    PcTeamNetProfitMargin?: number;
    PcUnitOverhead?: number;
    PcDepartmentOverhead?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamNetProfitMargin?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentOverhead?: number;


    // Relations
}

export interface RoNspFinancialNumbersByTeamByYearOLDEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    WachterDepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;
    FiscalYear?: number;
    CommittedFiscalYear?: number;
    CommittedTeamRevenue?: number;
    CommittedTeamCost?: number;
    CommittedTeamOverhead?: number;
    CommittedUnitRevenue?: number;
    CommittedUnitCost?: number;
    CommittedUnitPercentage?: number;
    CommittedUnitOverhead?: number;
    CommittedDepartmentRevenue?: number;
    CommittedDepartmentCost?: number;
    CommittedDepartmentPercentage?: number;
    CommittedDepartmentOverhead?: number;
    CommittedTeamGrossProfit?: number;
    CommittedTeamNetProfit?: number;
    CommittedTeamGrossProfitMargin?: number;
    CommittedTeamNetProfitMargin?: number;
    ProjectedFiscalYear?: number;
    ProjectedTeamRevenue?: number;
    ProjectedTeamCost?: number;
    ProjectedTeamOverhead?: number;
    ProjectedUnitRevenue?: number;
    ProjectedUnitCost?: number;
    ProjectedUnitPercentage?: number;
    ProjectedUnitOverhead?: number;
    ProjectedDepartmentRevenue?: number;
    ProjectedDepartmentCost?: number;
    ProjectedDepartmentPercentage?: number;
    ProjectedDepartmentOverhead?: number;
    ProjectedTeamGrossProfit?: number;
    ProjectedTeamNetProfit?: number;
    ProjectedTeamGrossProfitMargin?: number;
    ProjectedTeamNetProfitMargin?: number;
    YtdFiscalYear?: number;
    YtdTeamRevenue?: number;
    YtdTeamCost?: number;
    YtdTeamOverhead?: number;
    YtdUnitRevenue?: number;
    YtdUnitCost?: number;
    YtdUnitPercentage?: number;
    YtdUnitOverhead?: number;
    YtdDepartmentRevenue?: number;
    YtdDepartmentCost?: number;
    YtdDepartmentPercentage?: number;
    YtdDepartmentOverhead?: number;
    YtdTeamGrossProfit?: number;
    YtdTeamNetProfit?: number;
    YtdTeamGrossProfitMargin?: number;
    YtdTeamNetProfitMargin?: number;
    PcFiscalYear?: number;
    PcTeamRevenue?: number;
    PcTeamCost?: number;
    PcTeamOverhead?: number;
    PcUnitRevenue?: number;
    PcUnitCost?: number;
    PcUnitPercentage?: number;
    PcUnitOverhead?: number;
    PcDepartmentRevenue?: number;
    PcDepartmentCost?: number;
    PcDepartmentPercentage?: number;
    PcDepartmentOverhead?: number;
    PcTeamGrossProfit?: number;
    PcTeamNetProfit?: number;
    PcTeamGrossProfitMargin?: number;
    PcTeamNetProfitMargin?: number;
    ForecastedFiscalYear?: number;
    ForecastedTeamRevenue?: number;
    ForecastedTeamCost?: number;
    ForecastedTeamOverhead?: number;
    ForecastedUnitRevenue?: number;
    ForecastedUnitCost?: number;
    ForecastedUnitPercentage?: number;
    ForecastedUnitOverhead?: number;
    ForecastedDepartmentRevenue?: number;
    ForecastedDepartmentCost?: number;
    ForecastedDepartmentPercentage?: number;
    ForecastedDepartmentOverhead?: number;
    ForecastedTeamGrossProfit?: number;
    ForecastedTeamNetProfit?: number;
    ForecastedTeamGrossProfitMargin?: number;
    ForecastedTeamNetProfitMargin?: number;


    // Relations
}

export interface RoNspOverheadProjectedByDepartmentByYearEntity extends DwOrmData {
    // Attributes
    WachterDepartmentId?: number;
    FiscalYear?: number;
    Cost?: number;


    // Relations
}

export interface RoNspOverheadProjectedByTeamByYearEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    OrganizationalUnitId?: number;
    Cost?: number;


    // Relations
}

export interface RoNspProjectedByTeamEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    TeamId?: number;
    UnitId?: number;
    DepartmentId?: number;
    Revenue?: number;
    Cost?: number;


    // Relations
}

export interface RoOrganizationalTeamUnitDeptEntity extends DwOrmData {
    // Attributes
    TeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    DepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;


    // Relations
}

export interface RoOverheadCommittedByJobPhaseYearEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoOverheadProjectedByJobPhaseYearEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitName?: string;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    WachterDepartmentId?: number;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoOverheadProjectionByTeamEntity extends DwOrmData {
    // Attributes
    OverheadProjectionId?: number;
    OrganizationalTeamId?: number;
    FiscalYear?: number;
    TeamUnitId?: number;
    TeamUnitIsTeam?: boolean;
    HasRevenue?: boolean;
    Cost?: number;
    JobNumberId?: number;
    JobNumber?: string;
    PhaseId?: number;
    PhaseCode?: string;
    PhaseDescription?: string;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoProjectManagersTeamUnitDeptEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    HasRevenue?: boolean;
    PMNameFirstPreferredLast?: string;
    PMNameLastFirstPreferred?: string;
    PMNameFirstLast?: string;
    PMNamePreferredLast?: string;
    EthosTitle?: string;
    EthosEmail?: string;
    EthosSupId?: number;
    SupNameFirstPreferredLast?: string;
    SupNameLastFirstPreferred?: string;
    SupNameFirstLast?: string;
    SupNamePreferredLast?: string;
    TeamId?: number;
    TeamName?: string;
    TeamOwnerId?: number;
    TeamOwnerFirstPreferredLast?: string;
    TeamOwnerLastFirstPreferred?: string;
    TeamOwnerFirstLast?: string;
    TeamOwnerPreferredLast?: string;
    UnitId?: number;
    UnitName?: string;
    UnitOwnerId?: number;
    UnitOwnerFirstPreferedLast?: string;
    UnitOwnerLastFirstPrefered?: string;
    UnitOwnerFirstLast?: string;
    UnitOwnerPreferredLast?: string;
    DepartmentId?: number;
    DepartmentName?: string;
    DepartmentOwnerId?: number;
    DepartmentOwnerFirstPreferedLast?: string;
    DepartmentOwnerLastFirstPrefered?: string;
    DepartmentOwnerFirstLast?: string;
    DepartmentOwnerPreferedLast?: string;


    // Relations
}

export interface RoUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    Cost?: number;
    Revenue?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    ProjectionMonth?: string;


    // Relations
}

export interface NumbersRoUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    NameLastFirstPrefered?: string;
    FiscalYear?: number;
    Ethos_WachterTeamId?: number;
    TeamName?: string;
    ProjectedRevenue?: number;
    ProjectedCost?: number;
    ProjectedGP?: number;
    ProjectedGPM?: number;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;


    // Relations
}

export interface RoUserProjectionAnalyzedEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    UserId?: number;
    FiscalYear?: number;
    Revenue?: number;
    Cost?: number;
    Gross?: number;
    GrossMargin?: number;
    DateTimeProjected?: string;
    DateTimeUtcAnalyzed?: string;


    // Relations
}

export interface TeamYearNumbersEntity extends DwOrmData {
    // Attributes
    EthosTeamId?: number;
    FiscalYear?: number;
    CommittedRevenue?: number;
    ProjectedRevenue?: number;
    ForecastedRevenue?: number;
    ManagementRevenue?: number;
    CommittedGPM?: number;
    CommittedNPM?: number;
    ProjectedGPM?: number;
    ProjectedNPM?: number;
    ForecastedGPM?: number;
    ForecastedNPM?: number;
    ManagementGPM?: number;
    ManagementNPM?: number;
    RowInsertDateTime?: string;
    AccountingRevenue?: number;
    AccountingGPM?: number;
    AccountingNPM?: number;
    CommittedNetProfit?: number;
    ProjectedNetProfit?: number;
    ForecastedNetProfit?: number;
    AccountingNetProfit?: number;
    ManagementNetProfit?: number;

    // Display Attributes
    EthosTeamIdDisplay?: string;

    // Relations
    EthosTeamIdEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface TrustUserMergedEntity extends DwOrmData {
    // Attributes
    TrustUserMergedId?: number;
    New_UserId?: number;
    Old_UserId?: number;

    // Display Attributes
    New_UserIdDisplay?: string;
    Old_UserIdDisplay?: string;

    // Relations
    NewEthosUser? : EthosUserEntity;
    OldEthosUser? : EthosUserEntity;
}

export interface UserExtendedEntity extends DwOrmData {
    // Attributes
    UserExtendedId?: number;
    Ethos_UserId?: number;
    FosEthos_UserId?: number;
    TerritoryId?: number;
    TechTypeCv?: number;
    StartingPayRate?: number;
    OrientationDate?: string;
    PermDate?: string;
    Comments?: string;
    spOsgAttachmentId?: number;
    IsPersonalVehicleUseAllowed?: boolean;
    PersonalVehicleUseExpirationDate?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    HiringManagerEthos_UserId?: number;
    PayChangeDate?: string;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    TerritoryIdDisplay?: string;

    // Relations
    EthosEthosUser? : EthosUserEntity;
}

export interface WcUserProjectionEntity extends DwOrmData {
    // Attributes
    UserProjectionId?: number;
    Ethos_UserId?: number;
    FiscalYear?: number;
    Ethos_WachterTeamId?: number;
    Revenue?: number;
    Cost?: number;
    IsDeleted?: boolean;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    GrossProfit?: number;
    GrossProfitMargin?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    Ethos_WachterTeamIdDisplay?: string;

    // Relations
    EthosRoEthosUser? : RoEthosUserEntity[];
    ModifiedByEthosEthosUser? : EthosUserEntity;
    CreatedByEthosEthosUser? : EthosUserEntity;
    EthosEthosUser? : EthosUserEntity;
    EthosEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface UserTeamLookupEntity extends DwOrmData {
    // Attributes
    Ethos_UserId?: number;
    TeamId?: number;
    FiscalYear?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    TeamIdDisplay?: string;
    FiscalYearDisplay?: string;

    // Relations
    TeamIdEthosWachterTeam? : EthosWachterTeamEntity;
}

export interface UserYearNumbersEntity extends DwOrmData {
    // Attributes
    FiscalYear?: number;
    CommittedRevenue?: number;
    ProjectedRevenue?: number;
    ForecastedRevenue?: number;
    ManagementRevenue?: number;
    CommittedGPM?: number;
    CommittedNPM?: number;
    ProjectedGPM?: number;
    ProjectedNPM?: number;
    ForecastedGPM?: number;
    ForecastedNPM?: number;
    ManagementGPM?: number;
    ManagementNPM?: number;
    Ethos_UserId?: number;
    RowInsertDateTime?: string;
    AccountingRevenue?: number;
    AccountingGPM?: number;
    AccountingNPM?: number;
    WachterTeamId?: number;
    CommittedNetProfit?: number;
    ProjectedNetProfit?: number;
    ForecastedNetProfit?: number;
    AccountingNetProfit?: number;
    ManagementNetProfit?: number;

    // Display Attributes
    Ethos_UserIdDisplay?: string;
    WachterTeamIdDisplay?: string;

    // Relations
    EthosRoEthosUser? : RoEthosUserEntity;
    EthosWachterTeam? : EthosWachterTeamEntity;
}

export interface WachterTeamDepartmentEntity extends DwOrmData {
    // Attributes
    WachterTeamId?: number;
    TeamName?: string;
    DepartmentName?: string;
    DivisionShortName?: string;


    // Relations
}



